import React from "react";
import CareersSubNav from "../components/careersSubNav";
import { FiHome, FiClock, FiTrendingUp, FiMessageCircle } from "react-icons/fi";

const benefits = [
  { title: "Fully remote", description: "Work from wherever you're based — what matters is the output, not a fixed desk or city.", Icon: FiHome },
  { title: "Flexible hours", description: "A small set of shared check-ins aside, you largely structure your own working hours.", Icon: FiClock },
  { title: "Performance-based upside", description: "Compensation is tied to results and is expected to grow with the company — discussed openly at interview and reviewed regularly.", Icon: FiTrendingUp },
  { title: "Direct founder access", description: "No management layers to go through — feedback, questions, and decisions happen directly.", Icon: FiMessageCircle },
];

const Benefits = () => {
  return (
    <div>
      <section className="bg-cloud py-14 lg:py-20">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">Benefits</h1>
          <p className="mt-4 max-w-prose text-muted">
            We're early enough that we're straightforward about what's on
            offer today, rather than listing perks that don't exist yet.
          </p>
        </div>
      </section>

      <CareersSubNav />

      <section className="bg-paper py-16 lg:py-24">
        <div className="max-w-content mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-x-10 gap-y-10 md:grid-cols-2">
            {benefits.map(({ title, description, Icon }) => (
              <div key={title} className="border-t border-line pt-6">
                <Icon className="text-action" size={22} />
                <h3 className="mt-4 text-lg font-semibold text-charcoal">{title}</h3>
                <p className="mt-2 text-sm text-muted">{description}</p>
              </div>
            ))}
          </div>

          <p className="mt-14 max-w-prose text-sm text-muted">
            As the team grows past launch, we expect this list to grow too
            — including more structured benefits for full-time hires.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Benefits;
